import { AUTHORIZATION_API_URL } from '@/_constants';
import { NovatiqLoadingSpinnerHelper } from '@/_helpers';
import { HttpContextToken, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';

/** When true on a request context, the global loading overlay is not shown. */
export const SKIP_LOADING_SPINNER = new HttpContextToken<boolean>(() => false);

const pendingRequests = new Set<HttpRequest<unknown>>();

export const loadingSpinnerInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(SKIP_LOADING_SPINNER)) {
    return next(req);
  }

  const loadingHelper = inject(NovatiqLoadingSpinnerHelper);

  pendingRequests.add(req);

  if (!req.url.includes(AUTHORIZATION_API_URL.REFRESH_TOKEN)) {
    loadingHelper.start();
  }

  return next(req).pipe(
    finalize(() => {
      pendingRequests.delete(req);
      if (pendingRequests.size > 0) {
        loadingHelper.start();
      } else {
        loadingHelper.stop();
      }
    })
  );
};
